// extracted by mini-css-extract-plugin
export default {"container":"NotesContainer_container__0q8Ha","date":"NotesContainer_date__H3mod"};